import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Checkbox, Typography, IconButton, Tooltip } from '@mui/material';
import { AddIcon, CopyIcon } from 'Shared/Icons';
import SettingsIcon from '@mui/icons-material/Settings';
import FlowCopyForm from 'Shared/flows/flows-interface/FlowCopyForm';
import FlowIdLabel from 'Shared/flows/FlowIdLabel';
import FlowRunButton from 'Shared/flows/FlowRunButton';

export const UserPreDefinedFlowsItem = ({ item, linkFlowToUser, needUpdate, userRole, selected, onToggleSelect }) => {
  const navigate = useNavigate();
  const [visibleCopyFlowForm, setVisibleCopyFlowForm] = useState(false);

  const toFlow = (event, id) => {
    event.preventDefault();
    navigate(`/flow/${id}`);
  };

  const handleCopy = (e) => {
    e.stopPropagation();
    setVisibleCopyFlowForm(true);
  };

  // Show copy button only for Admin role (not for User or Company Admin)
  const showCopyButton = userRole === 'Admin';

  // Show settings icon when readonly = false (convert to boolean)
  const showSettingsIcon = !(item?.readonly === 1 || item?.readonly === '1' || item?.readonly === true);

  return (
    <>
      
      {showCopyButton && (
        <FlowCopyForm flowName={item.name}
          id={item.id}
          needUpdateList={needUpdate}
          setVisibleFlowForm={setVisibleCopyFlowForm}
          visibleFlowForm={visibleCopyFlowForm}
        />
      )}
      <Box
        sx={{
          marginBottom: '20px',
          padding: '16px',
          backgroundColor: '#F2F5F8',
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {onToggleSelect && (
            <Checkbox
                checked={selected}
                onClick={(e) => e.stopPropagation()}
                onChange={() => onToggleSelect(item)}
                sx={{ marginRight: '8px', flexShrink: 0 }}
            />
        )}
        <FlowIdLabel id={item.id} externalId={item.external_id} />
        <Box sx={{ flex: 1, minWidth: 0, marginRight: '16px' }}>
          <Typography
            variant="h6"
            sx={{
              color: '#3B465C',
              overflowWrap: 'anywhere',
            }}
          >
            {item?.name}
            {item?.company_name && (
              <span style={{ fontSize: '0.85rem', color: '#888', fontWeight: 400, marginLeft: 6 }}>
                ({item.company_name}{item?.author_name ? `, ${item.author_name}` : ''})
              </span>
            )}
          </Typography>
          {item?.description && item.description !== item.name && (
            <Typography
              variant="body2"
              sx={{ color: '#888', fontSize: '0.8rem', overflowWrap: 'anywhere' }}
            >
              {item.description}
            </Typography>
          )}
        </Box>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          {showSettingsIcon && <FlowRunButton flow={item} sx={{ order: 1 }} />}
          {showSettingsIcon && (
            <Tooltip title={
              <span style={{fontSize: '1rem', lineHeight: '120%'}}>Edit Flow</span>
            } arrow>
              <IconButton
                onClick={(e) => {
                  toFlow(e, item.id);
                }}
                sx={{
                  order: 1,
                }}
              >
                <SettingsIcon/>
              </IconButton>
            </Tooltip>
          )}
          <Button
            onClick={linkFlowToUser}
            startIcon={<AddIcon />}
            variant="outlined"
            size="small"
            sx={{
              fontSize: '0.75rem',
              height: '32px',
              minWidth: 'auto',
              padding: '4px 8px',
              order: 2,
            }}
          >
            Add to my active flows
          </Button>
          {showCopyButton && (
            <Tooltip title={
              <span style={{ fontSize: '1rem', lineHeight: '120%' }}>Copy Flow</span>
            } arrow>
              <IconButton
                onClick={handleCopy}
                sx={{
                  fontSize: '0.75rem',
                  height: '32px',
                  minWidth: 'auto',
                  padding: '4px 8px',
                }}
              >
                <CopyIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </Box>
    </>
  );
};
